export { default as FAQs } from "./FAQs.svelte";
